import { formatNumber, formatToOneDecimal } from "utils/formatHelpers";

type CardValueInput = {
  value?: number | string;
  footerTextSuffix?: string;
  headerText: string;
  roundToOneDecimal?: boolean;
};

const formatCardValue = (card: CardValueInput): string | number | undefined => {
  const { value, footerTextSuffix, headerText, roundToOneDecimal } = card;
  if (value === undefined || value === null || value === "") return undefined;

  if (footerTextSuffix === "%") {
    return Number(Number(value).toFixed(2));
  }
  if (typeof value === "string") {
    return value;
  }
  if (headerText === "Consumption") {
    return formatNumber(Math.round(Number(value)));
  }
  if (headerText === "System Size") {
    return Number(value)
      .toFixed(3)
      .replace(/\.?0+$/, "");
  }
  if (roundToOneDecimal) {
    return formatToOneDecimal(value);
  }
  return formatNumber(value);
};

const formatCardValueWithSuffix = (card: CardValueInput): string => {
  const formatted = formatCardValue(card);
  if (formatted === undefined) return "";
  const suffix = card.footerTextSuffix ? ` ${card.footerTextSuffix}` : "";
  return `${formatted}${suffix}`;
};

export { formatCardValue, formatCardValueWithSuffix };
